module.exports = __webpack_public_path__ + "static/media/check-mark.323bd918.svg";